import { lazy, Suspense } from 'react';
import { LoadingPage } from '../components/ui/LoadingSpinner';
import type { RouteDefinition } from './types';

const QuickChallenge = lazy(() => import('../pages/QuickChallenge'));

export const sessionRoutes: RouteDefinition[] = [
  // Quick streak saver (no RequireOnboarding — it's a streak-saver)
  { path: '/quick-challenge', element: <Suspense fallback={<LoadingPage />}><QuickChallenge /></Suspense>, guard: 'none' },
];
